import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: ".087",
  y: ".112",
  width: "33.492",
  height: "18.699",
  rx: "3.9",
  transform: "matrix(.9917 .12865 -.12434 .99224 2.364 -.01)",
  fill: "#EF6528"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: ".087",
  y: ".112",
  width: "33.492",
  height: "18.699",
  rx: "3.9",
  transform: "matrix(.9917 .12865 -.12434 .99224 2.364 -.01)",
  stroke: "#CACABE",
  "stroke-width": ".2"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.982 10.294 8.808 11.6l-3.576-.478.174-1.305 3.576.477ZM14.9 6.889l-.193 1.453-3.043-.406-.213 1.601c.242-.083.63-.135 1.118-.07 1.306.174 2.273 1.066 2.041 2.803-.224 1.68-1.368 2.636-3.015 2.417-1.589-.212-2.484-1.21-2.27-2.81l1.543.205c-.08.694.308 1.07.933 1.153.704.094 1.133-.357 1.232-1.095.104-.783-.247-1.27-.94-1.362a1.694 1.694 0 0 0-1.002.155l-1.385-.184.597-4.474 4.598.614ZM18.72 7.248c1.816.243 2.604 1.954 2.266 4.486-.339 2.543-1.55 3.999-3.367 3.757-1.816-.243-2.603-1.966-2.264-4.509.338-2.531 1.548-3.976 3.364-3.734Zm-.195 1.453c-.829-.11-1.379.81-1.603 2.49-.226 1.692.062 2.736.891 2.846.84.112 1.38-.82 1.607-2.512.224-1.68-.055-2.711-.895-2.824ZM23.986 7.95c1.135.152 1.894 1.132 1.74 2.29-.156 1.17-1.143 1.893-2.278 1.741-1.147-.153-1.898-1.108-1.742-2.277.155-1.158 1.133-1.906 2.28-1.753Zm5.384.87-5.33 7.377-1.305-.174 5.34-7.376 1.295.173Zm-5.536.266c-.477-.063-.869.277-.935.777-.066.488.222.93.699.994.465.063.848-.291.913-.78.066-.499-.211-.929-.677-.99Zm4.835 3.777c1.135.151 1.894 1.13 1.738 2.3-.154 1.158-1.14 1.882-2.276 1.73-1.147-.153-1.897-1.108-1.743-2.266.156-1.17 1.134-1.917 2.28-1.764Zm-.15 1.124c-.477-.064-.86.29-.926.79-.065.487.213.917.69.98.465.063.846-.28.91-.767.068-.5-.209-.941-.674-1.003Z",
  fill: "#fff"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }